import React from 'react';

import HomePage2 from '../Components/HomePage2';
import HomePage1 from './Components/HomePage1';
import Navbar from './Components/Navbar';




function HomePage() {
  return (
    <div className="homepage">
      <Navbar/>
      <HomePage1/>
      <HomePage2 />
    </div>
  );
}

export default HomePage;
